/**
 * @internal
 */
export var httpStore = new Map();
